export enum ModalStateNames {
  TransactionModal = 'createPortfolioOperationModal',
  OrderBookModal = 'createOrderTransactionModal',
  OrderModal = 'createOrderModal',
  OperationConfirmationComponent = 'portfolioOperationConfirmationComponent',
  CreatePortfolioModal = 'createPortfolioModal',
  LegalDisclaimerModal = 'showLegalDisclaimerModal',
  CreatePostModal = 'showCreatePostModal',
  ImageSliderModal = 'showImageSliderModal',
  PasswordResetModal = 'passwordResetModal',
  PortfolioEmptyStateModal = 'portfolioEmptyStateModal',
  CompareTickersModal = 'compareTickersModal',
  PortfolioShareModal = 'manageTeamPortfolioModal',
  ComparePortfolioModal = 'comparePortfoliosModal',
  CreateLeagueModal = 'createLeagueModal',
  CompanyTickersListModal = 'companyTickersListModal',
  NotificationCenterDrawer = 'notificationsCenterMenuDrawer',
  PortfolioOptionsDrawer = 'portfolioOptionsDrawer',
  PortfolioGuideDrawer = 'portfolioGuideDrawer',
  PortfolioGuideModal = 'portfolioGuideModal',
  HomePageGuideDrawer = 'homePageGuideDrawer',
  PortfolioSettingsModal = 'portfolioSettingsModal',
  UnrankedPortfolioConfirmationComponent = 'unrankedPortfolioConfirmationComponent',
  PortfolioSelectorModal = 'portfolioSelectorModal',
}
